import { BaseKioskConfigurationEntity } from 'api/KioskApi/entries';

export const mapPurposeOfStay = (
  purposeOfStay?: BaseKioskConfigurationEntity
): string | undefined => {
  return purposeOfStay?.description;
};
